module.exports = __webpack_public_path__ + "img/go-unimpact-min.31b7849e.jpg";